import { IApiUser, IApiUserPermissions, IUser, IUserPermissions } from './IUser'

class Transformer {
  static transformPermissions(
    permissions: IApiUserPermissions,
  ): IUserPermissions {
    return {
      ...permissions,
      hasAccessToSettings: permissions.has_access_to_settings,
      hrAbsencesManage: permissions['hr.absences.manage'],
      hrPunchClockManage: permissions['hr.punchclock.manage'],
      hrTargetsManage: permissions['hr.targets.manage'],
      hrTimeManage: permissions['hr.time.manage'],
      hrUsersManage: permissions['hr.users.manage'],
      marketingManage: permissions['marketing.manage'],
      isVisibleInCalendar: permissions.is_visible_in_calendar,
      isVisibleOnline: permissions.is_visible_online,
      settingsAccountManage: permissions['settings.account.manage'],
      settingsActivitiesManage: permissions['settings.activities.manage'],
      settingsOnlinePaymentManage:
        permissions['settings.online_payment.manage'],
      settingsRegisterManage: permissions['settings.register.manage'],
      settingsShopManage: permissions['settings.shop.manage'],
      settingsWebShopManage: permissions['settings.webshop.manage'],
    }
  }

  static transform(data: IApiUser): IUser {
    const permissions = data.permissions
      ? Transformer.transformPermissions(data.permissions)
      : undefined

    return {
      uuid: data.uuid,
      id: Number(data.id),
      firstName: data.first_name,
      lastName: data.last_name,
      isVisibleInCalendar: data.is_visible_in_calendar,
      isVisibleOnline: data.is_visible_online,
      avatar: data.avatar,
      isActive: !!(typeof data.is_active === 'undefined'
        ? !data.is_deleted
        : data.is_active),
      permissions,
      isCabin: !!data.is_cabine,
      isPartner: !!data.is_partner,
      establishmentId: data.establishment_id,
      outOfServiceAt: data.out_of_service_at,
      agbCode: data.agb_code,
      startsAt: data.starts_at,
    }
  }
}

export default Transformer
